module.exports = __webpack_public_path__ + "static/media/ic_bulp.19e29d7f.svg";